module.exports = "data:image/webp;base64,UklGRk4AAABXRUJQVlA4WAoAAAAQAAAAAQAAAQAAQUxQSA8AAAABD/AdpYgIMQER/Y8AAAAAVlA4IBgAAAAwAQCdASoCAAIAAUAmJaQAA3AA/v02aAA="